import { InjectionToken } from '@angular/core';

import { Square9ApiConfig } from './square9-api-config.model';

/** Square 9 API Config.  */
export const SQUARE9_API_CONFIG = new InjectionToken<Square9ApiConfig>(
  'SQUARE9_API_CONFIG'
);
